// src/api.js

const STRAPI_BASE_URL = process.env.REACT_APP_STRAPI_BASE_URL;
// const API_TOKEN = 'DEIN_STRAPI_API_TOKEN'; // Optional: Wenn deine API geschützt ist.
                                            // Ansonsten Zeile 4 & 13 entfernen.

export const fetchPageBySlug = async (slug) => {
  // DIE KORRIGIERTE populateParams KONSTRUKTION!
  const populateParams = [
    'populate[sections][populate][Logo][populate]=*',        // Jetzt korrekt mit 'populate[sections]'
    'populate[sections][populate][Background][populate]=*',   // Jetzt korrekt mit 'populate[sections]'
    'populate[sections][populate][Content][populate]=*',      // Jetzt korrekt mit 'populate[sections]'
    'populate[sections][populate][Link][populate]=*',
    'populate[sections][populate][Title][populate]=*',
    '&populate[Background][populate]=*'
  ].join('&'); // Fügt alle benötigten populate-Parameter zusammen

  const url = `${STRAPI_BASE_URL}/api/pages?filters[slug][$eq]=${slug}&${populateParams}`;
  console.log('API Aufruf URL (korrigiert):', url); // Zum Debuggen: Prüfe die final generierte URL

  try {
    const response = await fetch(url, {
      // headers: {
      //   Authorization: `Bearer ${API_TOKEN}`, // Nur wenn API Token benötigt
      // },
    });

    if (!response.ok) {
      const errorBody = await response.text();
      console.error('HTTP Fehler Antwort:', errorBody);
      throw new Error(`HTTP-Fehler! Status: ${response.status}. Antwort: ${errorBody}`);
    }

    let data;
    try {
      data = await response.json();
    } catch (jsonError) {
      console.error('Fehler beim Parsen der JSON-Antwort:', jsonError);
      throw new Error('Ungültige JSON-Antwort vom Server.');
    }

    if (data && data.data && data.data.length > 0) {
      console.log('Attribute der Seite (korrekt):', data.data[0].attributes);
      return data.data[0].attributes;
    } else {
      console.warn('Unerwartete Datenstruktur oder leere Antwort:', data);
      return null;
    }
  } catch (error) {
    console.error('Allgemeiner Fehler beim Abrufen der Seite:', error);
    throw error;
  }
};